module.exports = __webpack_public_path__ + "b59927544485747d1b06186a54394596.png";